import './styles/globals.css';

import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initClarity } from './clarity';
import { initSentry, reactErrorHandler } from './instrument';
import { router } from './router';

const root = document.getElementById('root');
if (root === null) throw new Error('index.html has no #root.');

initSentry(router);
initClarity();

createRoot(root, {
  onUncaughtError: reactErrorHandler(),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
}).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
